module.exports = __webpack_public_path__ + "770d96399dc4d6ae620b59a0c36fadfb.jpg";